// The maximum number of items to be displayed in the dashboard panels.
export const MAX_ITEMS_DASHBOARD = 6;
